import React from 'react';
import ButtonLoader from 'NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// METHOD FOR REMOVE ASSIGNEE CONFIRMATION MODAL
function ConfirmationModal({ title,subtitle,removeMethod, isFetchingProcessOn, setShowModalConfirmation }) {
      return <div className="modal fade show" id="modalContainer" >
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header unassignForm-header">
                    <div className="icon-container">
                        <FontAwesomeIcon icon={ ['fas', 'user-minus'] } size="lg" color='#0465AC' style={ { fontSize: 20 } } />
                    </div>
                    <h3 style={ { textTransform: "capitalize", fontSize: 20 } }>{title}</h3>
                    <FontAwesomeIcon icon={ ['fas', 'times'] } style={ { cursor: 'pointer' } } size="lg" color="#000000" onClick={ () => setShowModalConfirmation(false) } />
                </div>
                <div className="modal-body unassignForm-body">
                    <p>{subtitle}</p>
                </div>
                <div className="modal-footer unassignForm-footer">
                    
                    {
                        isFetchingProcessOn &&
                        <ButtonLoader />
                    }
                    <button className="btn primary-button" onClick={ () => { removeMethod(); } }> Remove</button>
                    <button className="btn outline-button" onClick={ () => setShowModalConfirmation(false) }>Cancel</button>
                </div>
            </div>
        </div>
    </div >
}

export default ConfirmationModal;
